module.exports = __webpack_public_path__ + "img/3.5d6b8d98.png";